export default "__VITE_ASSET__Du7IID2c__"